import { Alert } from "@mui/material";
import type React from "react";
import { useTranslation } from "react-i18next";
import { TestId } from "../../constants/testIds";
import { QA_BANNER_HEIGHT_PX } from "../../utils/environment";

interface QaEnvironmentBannerProps {
  visible: boolean;
}

const QaEnvironmentBanner: React.FC<QaEnvironmentBannerProps> = ({ visible }) => {
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <Alert
      severity="error"
      icon={false}
      data-testid={TestId.COMMON.QA_BANNER}
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.tooltip,
        justifyContent: "center",
        alignItems: "center",
        minHeight: QA_BANNER_HEIGHT_PX,
        height: "auto",
        py: 0.75,
        borderRadius: 0,
        fontWeight: 600,
        textAlign: "center",
        bgcolor: "#c62828",
        color: "#ffffff",
        "& .MuiAlert-message": {
          color: "#ffffff",
        },
      }}
    >
      {t(
        "You are on a test environment. Use https://exybox.net for real usage. https://qa.exybox.net may contain bugs and data may be deleted.",
      )}
    </Alert>
  );
};

export default QaEnvironmentBanner;
